function smoothScrollTo(target) {
    const offset = 100;
    const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    const duration = 200; // adjust the duration as needed
  
    let startTimestamp = null;
  
    function step(timestamp) {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = timestamp - startTimestamp;
      const easeInOutCubic = progress / duration;
      window.scrollTo(0, startPosition + distance * easeInOutCubic);
  
      if (progress < duration) {
        requestAnimationFrame(step);
      }
    }
  
    requestAnimationFrame(step);
}

function isElementInViewport(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);
  
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= windowHeight &&
      rect.left <= windowWidth
    );
}

class QuickNav {

	constructor(blockEl) {
		this.quickNav = blockEl;
        this.buttons = this.quickNav.querySelectorAll('.quick-nav__item button');
        this.targets = Array.from(this.buttons).map(button => {
            const targetId = button.getAttribute("data-target");
            return document.getElementById(targetId);
        });
        this.setEventHandlers()
	}
    
    setEventHandlers() {
        this.buttons.forEach((button) => {
            button.addEventListener("click", function () {
                const targetId = button.getAttribute("data-target");
                const targetDiv = document.getElementById(targetId);
          
                if (targetDiv) {
                  smoothScrollTo(targetDiv);
                }
            });
        })
        window.addEventListener("scroll", () => {
            this.updateActiveButtons();
        });
        this.updateActiveButtons(); // Initial check
    }

    updateActiveButtons() {
        this.targets.forEach((targetDiv) => {
          const targetId = targetDiv.id;
          const button = document.querySelector(`[data-target="${targetId}"]`);
          if (button && isElementInViewport(targetDiv)) {
            button.classList.add("active");
          } else if (button) {
            button.classList.remove("active");
          }
        });
    }
}

export default QuickNav;